import type { ROUTE_ADMIN } from './routes'

import { Navigation404Error } from '~/router/errors'

import { useUsersStore } from '~/entities/user/user/stores/users'

import type { NavigationGuard } from '~/typings/vue-router'

async function checkAdminPageAccess() {
  const userStore = useUsersStore()
  await userStore.fetchCurrentUser()
  if (userStore.currentUser?.tenant_admin === '1')
    return true

  throw new Navigation404Error('You are not a tenant admin')
}

export const navigationGuardAdminTenant: NavigationGuard<ROUTE_ADMIN> = (to, from, next) => {
  return Promise.resolve()
    .then(() => checkAdminPageAccess())
    .then(() => next())
    .catch(error => next(error))
}
